<template>
  <DecoratorState
    :hasTitleOnAdaptive="hasTitleOnAdaptive"
    title="Updating..."
    :hasTitle="hasTitle"
    class="state-updating"
  >
    <template #icon>
      <div class="state-updating__icon" />
    </template>
  </DecoratorState>
</template>

<script>
  import DecoratorState from '@/uikitProject/decorators/DecoratorState';

  export default {
    name: 'StateUpdating',

    components: {
      DecoratorState,
    },

    props: {
      hasTitle: {
        type: Boolean,
        default: true,
      },
      hasTitleOnAdaptive: {
        type: Boolean,
        default: true,
      },
    },
  };
</script>

<style lang="scss" scoped>
  .state-updating {
    color: $color-text-second;

    &__icon {
      display: inline-block;
      background-image: url('~assets/img/updating.svg');
      background-size: contain;
      margin: 0 0 2px 0;
      vertical-align: bottom;
      text-decoration: none;
      width: 15px;
      height: 15px;
    }
  }
</style>
